module.exports = __webpack_public_path__ + "img/palmas-room.fe07d0bc.jpg";